import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./navbar.css";
import logo from "../../assets/Redite-logo.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Navbar() {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate("/contactus");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleServices = (e) => {
    e.preventDefault();
    navigate("/service");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

    useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration (1 second)
      once: true,     // animation happens only once
    });
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top ">
      <div className="container d-flex justify-content-between align-items-center">
        {/* Logo */}
        <NavLink className="navbar-brand" to="/"
         data-aos="fade-left" >
          <img src={logo} alt="Logo" />
          {/* <figcaption className="logo-wordings">
            Formerly Called Fazo Software
          </figcaption> */}
        </NavLink>

        {/* Mobile toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav links */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav d-flex align-items-center gap-5 mb-0">
            <li className="nav-item">
           <NavLink
  to="/"
  className="nav-link"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
>
  Home
</NavLink>

            </li>

            <li className="nav-item">
              <NavLink to="/aboutus" className="nav-link"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                About
              </NavLink>
            </li>

            {/* Services Dropdown */}
            <li className="nav-item dropdown">
              <NavLink
                to="/service"
                className="nav-link dropdown-toggle"
                role="button"
                aria-expanded="true"
                onClick={handleServices}
              >
                Services
              </NavLink>
              <ul className="dropdown-menu">
                <li>
                  <NavLink className="dropdown-item" to="/webdevelopment"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    Web Development
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/software"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    Software Development
                  </NavLink>
                </li>
                 <li>
                  <NavLink className="dropdown-item" to="/digitalmarketing"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    Digital Marketing
                  </NavLink>
                </li>
                  <li>
                  <NavLink className="dropdown-item" to="/ecommerce"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    E-Commerce Website
                  </NavLink>
                </li>
                  <li>
                  <NavLink className="dropdown-item" to="/seo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    SEO Services
                  </NavLink>
                </li>
                  <li>
                  <NavLink className="dropdown-item" to="/logo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                   Logo Design
                  </NavLink>
                </li>
                  <li>
                  <NavLink className="dropdown-item" to="/webmaintance"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    Web Maintance
                  </NavLink>
                </li>
                  <li>
                  <NavLink className="dropdown-item" to="/testing"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    Software Testing
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Contact Dropdown */}
            <li className="nav-item dropdown">
              <NavLink
                to="/contactus"
                className="nav-link dropdown-toggle"
                role="button"
                aria-expanded="false"
                onClick={handleClick}
              >
                Contact
              </NavLink>
              <ul className="dropdown-menu">
                <li>
                  <NavLink className="dropdown-item" to="/faq"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    FAQ
                  </NavLink>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
